import { html, LitElement } from 'lit';

import styles from './divider.styles';

export class Divider extends LitElement {
	static override styles = [styles()];

	override render() {
		return html` <hr class="m-divider" /> `;
	}
}

window.customElements.define('m-divider', Divider);

declare global {
	interface HTMLElementTagNameMap {
		'm-divider': Divider;
	}
}
